module.exports = __webpack_public_path__ + "images/turtle-5aa33a.svg";